import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import TooltipOnEllipsis from '../tooltipOnEllipsis/tooltipOnEllipsis';
var validValues = {
  sizes: {
    options: ['tiny', 'small', 'medium', 'large'],
    defaultValue: 'medium'
  },
  weights: {
    options: ['thin', 'normal', 'bold'],
    defaultValue: 'normal'
  },
  skins: {
    options: ['standard', 'placeholder', 'premium', 'alert', 'success', 'link', 'secondary'],
    defaultValue: 'standard'
  }
};
var Text = /*#__PURE__*/function (_React$PureComponent) {
  function Text(props) {
    var _this;
    _classCallCheck(this, Text);
    _this = _callSuper(this, Text, [props]);
    _this.getValidStylingValues = function (values) {
      var size = values.size.toLowerCase();
      var weight = values.weight.toLowerCase();
      var skin = values.skin.toLowerCase();
      return {
        validSize: validValues.sizes.options.includes(size) ? size : validValues.sizes.defaultValue,
        validWeight: validValues.weights.options.includes(weight) ? weight : validValues.weights.defaultValue,
        validSkin: validValues.skins.options.includes(skin) ? skin : validValues.skins.defaultValue
      };
    };
    return _this;
  }
  _inherits(Text, _React$PureComponent);
  return _createClass(Text, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        light = _this$props.light,
        dataHook = _this$props.dataHook,
        enableEllipsis = _this$props.enableEllipsis,
        customEllipsisProps = _this$props.customEllipsisProps,
        disabled = _this$props.disabled,
        skin = _this$props.skin,
        size = _this$props.size,
        weight = _this$props.weight,
        translateIfNeeded = _this$props.translateIfNeeded;
      var _this$getValidStyling = this.getValidStylingValues({
          skin: skin,
          size: size,
          weight: weight
        }),
        validSize = _this$getValidStyling.validSize,
        validWeight = _this$getValidStyling.validWeight,
        validSkin = _this$getValidStyling.validSkin;
      var finalSkin = this.getFinalSkin(disabled, light, validSkin);
      return /*#__PURE__*/React.createElement("span", {
        "data-hook": dataHook,
        "data-enable-ellipsis": enableEllipsis,
        "data-disabled": disabled,
        className: "control-text size-".concat(validSize, " weight-").concat(validWeight, " skin-").concat(finalSkin)
      }, enableEllipsis ? /*#__PURE__*/React.createElement(TooltipOnEllipsis, customEllipsisProps, translateIfNeeded(children)) : translateIfNeeded(children));
    }

    // If disabled or light props are passed then we override the skin
  }, {
    key: "getFinalSkin",
    value: function getFinalSkin(disabled, light, skin) {
      var selectedSkin = null;
      if (disabled) {
        selectedSkin = 'disabled';
      } else if (light && skin === 'standard') {
        selectedSkin = 'standard-light';
      } else if (light && skin === 'secondary') {
        selectedSkin = 'secondary-light';
      }
      selectedSkin = selectedSkin || skin;
      return selectedSkin;
    }
  }]);
}(React.PureComponent);
Text.displayName = 'Text';
Text.propTypes = {
  /** The actual text to be rendered */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Font-size of the text */
  size: PropTypes.oneOf(validValues.sizes.options),
  /** Font weight of the text */
  weight: PropTypes.oneOf(validValues.weights.options),
  /** Skin color of the text */
  skin: PropTypes.oneOf(validValues.skins.options),
  /** Set text with lighter color - effect Standard and Secondary skins only */
  light: PropTypes.bool,
  /** Set text with disabled styling */
  disabled: PropTypes.bool,
  /** When set to false the text goes multiline without ellipsis nor tooltip */
  enableEllipsis: PropTypes.bool,
  /** Custom props to override the default behaviour of the wrapping ToolTipOnEllipsis component */
  customEllipsisProps: PropTypes.object
};
Text.defaultProps = {
  dataHook: 'Text',
  size: validValues.sizes.defaultValue,
  weight: validValues.weights.defaultValue,
  skin: validValues.skins.defaultValue,
  light: false,
  disabled: false,
  enableEllipsis: true
};
export default compose(Text);